import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressBook, faArrowRight, faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons';
import { Button } from 'components/ui/button';

import { useConversationContext } from '../conversation_context';

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

// TODO: Replace with dynamic starters
const STARTERS = [
  {
    icon: faAddressBook,
    label: 'Find a contact',
    sub: 'Search your contacts by name or company',
    prompt: 'Help me find a contact',
  },
  {
    icon: faMagnifyingGlass,
    label: 'Look up contact details',
    sub: 'Pull up everything on one of your contacts',
    prompt: 'Look up the details for one of my contacts',
  },
];

function greeting(firstName?: string | null): string {
  const hour = new Date().getHours();
  const partOfDay = hour < 12 ? 'Morning' : hour < 17 ? 'Afternoon' : 'Evening';
  return firstName ? `${partOfDay}, ${firstName}. How can I help?` : `${partOfDay}. How can I help?`;
}

function StarterIcon({ icon }: { icon: IconDefinition }) {
  return (
    <span
      className={'ai-assistant-starter-icon bg-gradient-ai-decorative d-inline-flex align-items-center'
        + ' justify-content-center rounded-circle flex-shrink-0 text-primary'}
    >
      <FontAwesomeIcon icon={icon} />
    </span>
  );
}

interface Props {
  onSelect: (prompt: string) => void;
}

export default function ConversationStarters({ onSelect }: Props) {
  const { firstName, hasResumableChat, resumePreviousChat } = useConversationContext();

  return (
    <div className="pt-3">
      {hasResumableChat && (
        <div className="mb-3">
          <Button
            className="text-primary fw-semibold px-0"
            iconEnd={faArrowRight}
            label="Resume chatting"
            size="sm"
            variant="ghost"
            onClick={resumePreviousChat}
          />
        </div>
      )}

      <h4 className="text-primary fw-bold mb-4">{greeting(firstName)}</h4>

      <div className="d-flex flex-column gap-1">
        {STARTERS.map(starter => (
          <Button
            className={'bg-gradient-ai-card-hover border-hover-purple-heart-300 d-flex align-items-center'
              + ' gap-2 p-2 text-start text-body'}
            key={starter.label}
            variant="ghost"
            onClick={() => onSelect(starter.prompt)}
          >
            <StarterIcon icon={starter.icon} />
            <span className="flex-grow-1">
              <span className="fw-semibold">{starter.label}</span>
              <span className="text-muted small ms-2">{starter.sub}</span>
            </span>
          </Button>
        ))}
      </div>
    </div>
  );
}
